exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.share-button[data-v-71370dd4] {\n  margin: 0 5px;\n  width: 45px;\n  height: 45px;\n}\n.share-button--white circle[data-v-71370dd4] {\n  stroke: white;\n}\n.share-button--white path[data-v-71370dd4] {\n  fill: white;\n}", ""]);

// exports
